<template>
  
  <div class="w-100" style="border-top: solid 1px #d8d8d8">
    
    <h1 class="d-flex flex-column align-items-center">Formulario de denuncias UCC</h1>
    
    <div class="d-flex flex-column p-3 align-items-center">

        <fieldset-component texto="Datos personales" bold class="mb-3 w-50" />
        
        <div class="d-flex flex-row w-50">

          <label class="mr-2 mb-3">¿Mantener anonimato?</label>
          <label class="mr-3">
            <input
              type="radio"
              :value=true
              v-model="anonymousOption"
              name="anonymous"
            />
            Sí
          </label>
  
          <label>
            <input
              type="radio"
              :value=false
              v-model="anonymousOption"
              @click="name = null; lastName = null; contactNumber = null; email = null;"
              name="anonymous"
            />
            No
          </label>

        </div>
        

        <div v-if=!anonymousOption  id="datosPersonales" class="mb-3 d-flex flex-column w-50">

          <div class="d-flex flex-row w-75">
            
            <ui-textbox 
              class="w-75 me-5"
              floating-label 
              label="Nombre" 
              type="text" 
              enforce-maxlength 
              :maxlength="30" 
              v-model="name" 
            />
          
            <ui-textbox 
            class="w-75 me-5"
              floating-label 
              label="Apellidos" 
              type="text" 
              enforce-maxlength 
              :maxlength="30" 
              v-model="lastName" 
            />

          </div>

          
          <div class="d-flex flex-row w-75">
            <ui-textbox 
            class="w-75 me-5"
            floating-label 
            label="Teléfono" 
            type="number" 
            enforce-maxlength 
            :maxlength="11" 
            v-model="contactNumber" 
          />
          
          <ui-textbox 
            class="w-75 me-5"
            floating-label 
            label="Correo" 
            type="text" 
            enforce-maxlength 
            :maxlength="40" 
            v-model="email" 
          />
          </div>
          
          
        </div>


        <fieldset-component texto="Antecedentes" bold class="mb-3 w-50" />

        <div id="antecedentes" class="d-flex flex-row w-50 gap-5">
          <ui-select
            class="w-40"
            label="¿Cuál es su relación con UCC? (*)" 
            placeholder="Seleccionar" 
            searchPlaceholder="Buscar" 
            :keys     = "formatSelect" 
            :options  = "relationshipSelect"
            v-model   = "selectedRelationship"
          />
          
          <ui-textbox v-if="selectedRelationship.id == 4"
            floating-label 
            class="w-25"
            label="Detalle" 
            type="text" 
            enforce-maxlength 
            :maxlength="30" 
            v-model="otherRelationship" 
          />
          <ui-select
            class="w-25"
            label="Seleccione sucursal (*)" 
            placeholder="Seleccionar" 
            searchPlaceholder="Buscar" 
            :keys     = "formatSelect" 
            :options  = "branchSelect" 
            v-model   = "selectedBranch" 
          />

        </div>

        <div class="mb-3 w-50">
          <ui-textbox 
            
            floating-label 
            label="Oficina o lugar donde ocurrió el hecho: (*)" 
            type="text" 
            enforce-maxlength 
            :maxlength="50" 
            v-model="placeOcurred" 
          />
        </div>
    
        <fieldset-component texto="Identificación del tipo de denuncia" bold class="mb-3 w-50" />

        <div class="d-flex flex-row  w-50 mb-3">

          <ui-select
              class="w-50 me-5"
              label="Por favor, seleccione la categoría de la denuncia (*)" 
              placeholder="Seleccionar" 
              searchPlaceholder="Buscar" 
              :keys     = "formatSelect" 
              :options  = "generalCategorySelect" 
              v-model   = "selectedCategory"
              @change="getSecondaryCategories(); selectedSubCategory = []"
           />
           
           <ui-select v-if="showSubcategory"
              class="w-50"
              label="Por favor, seleccione la subcategoría de la denuncia" 
              placeholder="Seleccionar" 
              searchPlaceholder="Buscar" 
              :keys     = "formatSelect" 
              :options  = "subCategorySelect" 
              v-model   = "selectedSubCategory"
              :disabled= "subCategoryDisabled"
              />
        </div>

        <div class="align-items-left w-50">
          <ui-textbox v-if="showCommentaries"
            floating-label 
            label="Campo libre (*)" 
            type="text" 
            enforce-maxlength 
            :maxlength="50" 
            v-model="commentsTypeDenunciation" 
          />
        </div>

        <fieldset-component texto="Detalles generales" bold class=" w-50 mb-3" />
        
        <div class="d-flex flex-row  align-items-left w-50">
          
          <ui-textbox 
            floating-label 
            class="w-100"
            label="¿Cómo ocurrieron los hechos? (*)" 
            type="text"
            enforce-maxlength 
            :maxlength="250" 
            v-model="generalComments" 
          />
        </div>

        <fieldset-component texto="Contacto" bold class=" w-50 mb-3" />

        <div class="d-flex flex-row w-50">
          
          <label class="mr-2 mb-3">¿Quieres que te contacten?</label>
  
          <label class="mr-3">
            <input
              type="radio"
              :value=true
              v-model="toBeContacted"
              name="toBeContacted"
            />
            Sí
          </label>
  
          <label>
            <input
              type="radio"
              :value=false
              v-model="toBeContacted"
              name="toBeContacted"
              @click="contactTypeOption = null; emailContact = null; phoneContact = null;"
            />
            No
          </label>

        </div>
        
        
        <div v-if=toBeContacted class="d-flex flex-row w-50">

          <label class="mr-2 mb-3">Selecciona el canal</label>
  
          <label class="mr-3">
            <input
              type="radio"
              :value=1
              v-model="contactTypeOption"
              name="contactTypeOption"
            />
            Correo electrónico
          </label>
  
          <label class="mr-3">
            <input
              type="radio"
              :value=2
              v-model="contactTypeOption"
              name="contactTypeOption"
            />
            Teléfono
          </label>
          
          <label class="mr-3">
            <input
              type="radio"
              :value=3
              v-model="contactTypeOption"
              name="contactTypeOption"
            />
            Ambos
          </label>

        </div>


        <div v-if="contactTypeOption==1 || contactTypeOption==3" class="d-flex flex-column w-50">
            
            <ui-textbox
              class="w-50 me-5"
              floating-label
              label="Correo"
              type="text"
              enforce-maxlength
              :maxlength="40"
              v-model="emailContact"
            />

        </div>
        
        
        <div v-if="contactTypeOption==2 || contactTypeOption==3" class="d-flex flex-column w-50">
            
            <ui-textbox
              class="w-50 me-5"
              floating-label
              label="Teléfono"
              type="number"
              enforce-maxlength
              :maxlength="11"
              v-model="phoneContact"
            />

        </div>
        
        
        
        <div class="d-flex flex-row pt-5 w-25">

          <Button
          class="w-50 me-5 "
            :size="17"
            :width="170"
            :height="30"
            text="Limpiar formulario"
            color="#ff0000"
            colorText="#ffffff"
            icon=""
            tooltip="Limpiar formulario"
            horizontal
            @click.native="resetForm"
          />
          
          <Button
          class="w-50 me-5 align-items-right"
            :size="17"
            :width="170"
            :height="30"
            text="Enviar denuncia"
            color="#0174f3"
            colorText="#ffffff"
            icon=""
            tooltip="Enviar denuncia"
            horizontal
            @click.native="send"
          />
        </div>
        
      </div>
      
      <resumen-denuncia-modal
      :dataDenuncia="dataDenuncia"      
      />


  </div>
  
</template>

<script >

import { mapActions } from "vuex";
import Vue from "vue";
import Button from "@/components/common/Button.vue";
import VueToastify from "vue-toastify";
import fieldsetComponent from "@/components/common/FieldsetComponent.vue";
import ResumenDenunciaModal from "@/components/modals/denuncias/ResumenDenunciaModal.vue";


Vue.use(VueToastify);



import {
  getDataDenunciationsOptions,
  saveDenunciation

} from "../../constants/lineas";

export default {
  components: {
    Button,
    ResumenDenunciaModal,
    fieldsetComponent,
  },
  data() {
    return {

      //options
      relationshipSelect        : [],
      generalCategorySelect     : [],
      subCategorySelect         : [],
      branchSelect              : [],
      anonymousOption           : false,
      toBeContacted             : true,
      contactTypeOption         : null,
      phoneContact              : null,
      emailContact              : null,


      //v-models
      selectedRelationship      : [],
      selectedCategory          : [],
      selectedSubCategory       : [],
      selectedBranch            : [],
      otherRelationship         : "",
      name                      : "",
      lastName                  : "",
      contactNumber             : "",
      email                     : "",
      isAnonymous               : null,
      commentsTypeDenunciation  : "",
      placeOcurred              : "",
      generalComments           : "",
      dataDenuncia              : {
        relationship              : "",
        branch                    : "",
        category                  : "",
        subcategory               : "",
        placeOcurred              : "",
        commentsTypeDenunciation  : "",
        generalComments           : "",
        idDenuncia                : null,
        name                      : "",
        lastName                  : "",
        contactNumber             : "",
        email                     : "",
        otherRelationship         : "",
      },

      //all categories
      allSubCategories          : [],

      //flags
      showSubcategory           : true,
      showCommentaries          : false,
      subCategoryDisabled       : true,


      formatSelect          : { value: 'id', label: 'name' } ,
    };
  },
  
  methods: {

    ...mapActions("lineas", [
      "actionSetvisibleModalResumenDenuncia"
    ]),

    async dataSelects(){
      const {
        lista_relacion,
        lista_categorias_principales,
        lista_categorias_secundarias,
        lista_sucursales
      } = await getDataDenunciationsOptions();

      this.relationshipSelect     = lista_relacion;
      this.generalCategorySelect  = lista_categorias_principales;
      this.allSubCategories       = lista_categorias_secundarias;
      this.branchSelect           = lista_sucursales;
      
    },

    async getSecondaryCategories(){
      
      if (!this.selectedCategory) {

        this.subCategorySelect = [];
        this.subCategoryDisabled = true;
        return;
      }

      if (this.selectedCategory.id == 4) {
      
        this.showSubcategory  = false;
        this.showCommentaries = true;
        
      }else{
      
        this.showSubcategory      = true;
        this.showCommentaries     = false;
        this.subCategoryDisabled  = false;

      }
      this.subCategorySelect = this.allSubCategories.filter((item) => item.id_category == this.selectedCategory.id);  
    },
    async send(){
      
      
      const valid = this.validForm();

      if (!valid) return false;

      const data = this.prepareData();
      
      this.dataDenuncia = data;

      this.$vToastify.loader("Enviando denuncia...");
      
      const response = await saveDenunciation(data);
      
      this.dataDenuncia = {
        isAnonymous               : data.isAnonymous,
        name                      : data.name,
        lastName                  : data.lastName,
        contactNumber             : data.contactNumber,
        email                     : data.email,
        relationship              : data.relationship,
        otherRelationship         : data.otherRelationship,
        branch                    : data.branch.name,
        placeOcurred              : data.placeOcurred,
        category                  : data.category,
        subcategory               : data.subcategory,
        commentsTypeDenunciation  : data.commentsTypeDenunciation,
        generalComments           : data.generalComments,
        toBeContacted             : data.toBeContacted,
        emailContact              : data.emailContact,
        phoneContact              : data.phoneContact,
        idDenuncia                : response.idDenuncia,
        contactTypeOption         : data.contactTypeOption,
        

      }
      
      this.$vToastify.stopLoader();
      
      if (!response.error) {
        this.$vToastify.success(response, "¡Denuncia enviada con éxito!");
      }
      // Acá reemplazar el mensaje por un modal que contenga todos los datos que se enviaron

      this.actionSetvisibleModalResumenDenuncia(true);

      
      this.resetForm();
    },

    validForm(){
      
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      
      if (!this.anonymousOption) {
        if (!this.name) {
          this.$vToastify.error("Debe ingresar su nombre", "¡Error!");
          return false;
        }
        
        if (!this.lastName) {
          this.$vToastify.error("Debe ingresar su apellido", "¡Error!");
          return false;
        }

        if (!this.contactNumber) {
          this.$vToastify.error("Debe ingresar un número de contacto", "¡Error!");
          return false;
        }
        
        if (!emailPattern.test(this.email)) {
          this.$vToastify.error("Por favor, ingrese un email con formato válido", "Error: Email inválido");
          return false;
        }
      }

      if (!this.selectedRelationship?.id) {
        this.$vToastify.error("Debe seleccionar una relación con UCC", "¡Error!");
        return false;
      }else{
        if (this.selectedRelationship.id == 4 && !this.otherRelationship) {
            this.$vToastify.error("Debe ingresar detalle de su relación con UCC", "¡Error!");
            return false;
        }
      }

      if (!this.selectedBranch?.id){
        this.$vToastify.error("Debe seleccionar sucursal", "¡Error!");
        return false;
      }

      if (!this.placeOcurred) {
        this.$vToastify.error("Debe ingresar el lugar donde ocurrió el hecho", "¡Error!");
        return false;
      }

      if (!this.selectedCategory?.id) {
        this.$vToastify.error("Debe seleccionar una categoría", "¡Error!");
        return false;
        
      }else if (this.selectedCategory.id == 4 && !this.commentsTypeDenunciation) {
        
        this.$vToastify.error("Debe especificar el tipo de denuncia", "¡Error!");
          return false;
      }

      if (!this.generalComments) {
        this.$vToastify.error("Debe ingresar una descripción de los hechos", "¡Error!");
        return false;
      }

      if (this.toBeContacted && this.contactTypeOption === null) {
        this.$vToastify.error("Debe seleccionar un canal de contacto", "¡Error!");
        return false;
      }else if(this.toBeContacted && this.contactTypeOption == 1 && !this.emailContact) {
        this.$vToastify.error("Debe ingresar un correo electrónico", "¡Error!");
        return false;
      }else if(this.toBeContacted && this.contactTypeOption == 2 && !this.phoneContact) {
        this.$vToastify.error("Debe ingresar un número de teléfono", "¡Error!");
        return false;
      }else if(this.toBeContacted && this.contactTypeOption == 3 && (!this.emailContact || !this.phoneContact)) {
        this.$vToastify.error("Debe ingresar un correo electrónico y un número de teléfono", "¡Error!");
        return false;
      }

      return true;

    },
    prepareData(){

      const toreturn = {
        isAnonymous               : this.anonymousOption,
        name                      : this.name,
        lastName                  : this.lastName,
        contactNumber             : this.contactNumber,
        email                     : this.email,
        relationship              : this.selectedRelationship,
        otherRelationship         : this.otherRelationship,
        branch                    : this.selectedBranch,
        placeOcurred              : this.placeOcurred,
        category                  : this.selectedCategory,
        subcategory               : this.selectedSubCategory,
        commentsTypeDenunciation  : this.commentsTypeDenunciation,
        generalComments           : this.generalComments,
        toBeContacted             : this.toBeContacted,
        emailContact              : this.emailContact,
        phoneContact              : this.phoneContact,
        idDenuncia                : this.idDenuncia,
        contactTypeOption         : this.contactTypeOption,
        
      };

      return toreturn;
    },

    resetForm(){

      this.anonymousOption          = false;
      this.selectedRelationship     = [];
      this.selectedCategory         = [];
      this.selectedSubCategory      = [];
      this.selectedBranch           = [];
      this.commentsTypeDenunciation = "";
      this.generalComments          = "";
      this.placeOcurred             = "";
      this.name                     = "";
      this.lastName                 = "";
      this.contactNumber            = "";
      this.email                    = "";
      this.otherRelationship        = "";
      this.showSubcategory          = true;
      this.subCategoryDisabled      = true;
      this.showCommentaries         = false;
      this.toBeContacted            = true;
      this.contactTypeOption        = null;
      this.emailContact             = null;
      this.phoneContact             = null;
    },
    
  },

  created(){
    this.dataSelects() ;
  }
};




</script>

<style>  
#datosPersonales .ui-select {
  width: 60% !important;
}

#datosPersonales .ui-focus-container {
  margin-top: 0px !important;
}



</style>